/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/masx_userlist.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {
  GET_OPEN_INVITE_MASQUERADER_LIST,
  GET_PRESENTATION,
  GetOpenReg,
} from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { pretty } from "@vlinder-web/utils-react";
import { ManageOpenRegistraionService } from "..";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const is = require("is_js");
export interface IMasqueraderListsMethods extends IPluginMethodMap {
  getMasqueraderListsProps(args: any): Promise<any>;
}
const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    "services.ManageOpenRegistraionService"
  ) as ManageOpenRegistraionService;
};
export class MasqueraderListsService implements IAgentPlugin {
  readonly methods: IMasqueraderListsMethods;

  constructor() {
    this.methods = {
      getMasqueraderListsProps: this.getMasqueraderListsProps.bind(this),
    };
  }

  async getMasqueraderListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let filter = {};
    console.log("helooprint", args);
    const searchType = this.determineSearchType(args?.criteria);
    if (searchType && searchType !== null) {
      if (searchType === "multi") {
        filter = this.getMultiFilter(args?.criteria);
      }
      //  else if (searchType === "status") {
      //   filter = this.convertDropDown(args?.criteria);
      // }
      else {
        filter = this.convertCriteria(args?.criteria);
      }
    }

    const options = {
      limit: args?.size ?? 10,
      skip: args?.offset ?? 0,
      sort: {
        field: "createdAt",
        order: "desc",
      },
    };

    const renderPresentation = async () => {
      const data1 = await getSrv()?.getInviteUser();

      let presentation =
        data1?.response?.getOpenInvite[0]?.presentation?.id ?? "";

      return presentation;
    };

    console.log("filter in service====", await renderPresentation());
    try {
      if (client) {
        const id = await client.query({
          query: GetOpenReg,
          variables: {},
          fetchPolicy: "network-only",
        });
        if (id?.data) {
          const _res = await client.query({
            query: GET_PRESENTATION,
            variables: {},
            fetchPolicy: "network-only",
          });
          const activeItem = _res?.data?.getPresentations?.content.find(
            (item: any) => item.status === "active"
          );
          let activePresentation =
            activeItem && activeItem?.id
              ? activeItem?.id
              : _res?.data?.getPresentations?.content[0]?.id;
          let defaultPresentation =
            args?.criteria?.presentation ??
            args?.presentation ??
            activePresentation;
          // filter = {
          //   ...filter,
          //   Referal___presentation: {
          //     eq: defaultPresentation
          //   }
          // }
          const res = await client.query({
            query: GET_OPEN_INVITE_MASQUERADER_LIST,
            variables: {
              options: options,
              filters: {
                ...filter,
                InviteBy___email: {
                  eq: id?.data?.getOpenReg?.user?.email,
                },
                presentation: {
                  eq: defaultPresentation,
                },
              },
            },
            fetchPolicy: "network-only",
          });
          if (res?.data) {
            console.log("data for userTable====", pretty(res?.data));
            let _rowData = this.formatUserTable(
              res?.data?.getReferals?.content
            );

            let _totalPages = res?.data?.getReferals?.count
              ? Math.ceil(parseInt(res?.data?.getReferals?.count) / 10)
              : 1;

            let _currentPage =
              res?.data?.getReferals?.skip / res?.data?.getReferals?.limit + 1;
            console.log(
              "pagination====",
              _totalPages,
              _currentPage,
              res?.data?.getReferals?.count
            );
            let presentationOptions: any = [];
            presentationOptions = _res?.data?.getPresentations?.content?.map(
              (_item: any) => {
                return {
                  value: _item?.id,
                  label: _item?.name,
                  year: _item?.year,
                };
              }
            );
            return {
              ...config,
              ultUsers: _rowData,
              isEmpty: res?.data?.getReferals?.content?.length <= 0,
              activePage: _currentPage,
              pageSize: res?.data?.getReferals?.limit,
              totalCount: res?.data?.getReferals?.count,
              totalPages: _totalPages,
              searchPresentationFilter: presentationOptions,
              defaultPresentation: defaultPresentation,
            };
          }
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private formatUserTable(data: any) {
    console.log(`databbbbb`, data);
    let _rowData: any = [];
    data &&
      data.forEach((item?: any) => {
        _rowData.push({
          id: item?.user?.id,
          userId: item?.user?.id,
          boxStatus: item?.box?.boxStatus ?? "-",
          section: item?.sections?.name ?? "-",
          sectionOption: item?.sectionOptType ?? "-",
          partition: item?.partition ?? "-",
          status: item?.inviteStatus ?? "-",
          amountPaid: item?.box?.amountPaid
            ? item?.box?.amountPaid?.toFixed(2)
            : 0,
          totalAmount: item?.box?.totalAmount
            ? item?.box?.totalAmount.toFixed(2)
            : 0,
          paymentStatus: item?.box?.paymentStats ?? "-",
          userStatus: this.getFormattedStatus(
            item?.user?.accountStatus,
            item?.user?.suspended
          ),
          sectionId: item?.sections?.id ?? "-",
          presentationName: item?.presentation?.name ?? "",
          presentationId: item?.presentation?.id ?? "",
          name: `${
            item?.user?.firstName && item?.user?.firstName !== ""
              ? item?.user?.firstName
              : "-"
          } ${
            item?.user?.lastName && item?.user?.lastName !== ""
              ? item?.user?.lastName
              : " "
          }`,
          email: item?.user?.email ?? "-",
          gender: item?.user?.gender ?? "-",
          costumeID: item?.box?.costumeID ?? "-",
          invitedBy:
            item?.invitedBy[0]?.fullName && item?.invitedBy[0]?.fullName !== ""
              ? item?.invitedBy[0]?.fullName
              : "-",
          createdAt: this.formatCreatedDate(item?.updatedAt) ?? "-",
          inviteNote: item?.inviteNote ?? "-",
        });
      });
    console.log(`databbbbb1`, _rowData);
    return _rowData;
  }

  private determineSearchType(criteria: any) {
    if (Object.keys(criteria).length === 0) {
      return "default";
    }
    // else if (Object.keys(criteria)[0] === "status") {
    //   return "status";
    // }
    else if (Object.keys(criteria)[0] === "0") {
      return "multi";
    } else {
      return "normal";
    }
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format("LL");
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      if (
        key === "presentation" ||
        (key === "User___inviteStatus" && criteria[key] === "all")
      ) {
        continue;
      } else {
        result[key] = { contains: criteria[key] };
      }
    }
    return result;
  }

  private convertDropDown(criteria: any) {
    console.log("dropdoewn", Object.values(criteria)[0]);
    const result: any = {};
    for (const key in criteria) {
      result["Boxes___boxStatus"] = Object.values(criteria)[0];
    }
    return result;
  }

  private getMultiFilter(criteria: any) {
    const transformedCriteria: any = {};
    for (const key in criteria) {
      if (criteria.hasOwnProperty(key)) {
        const { key: filterKey, filters } = criteria[key];
        const { inputData } = filters;
        const filterType = Object.keys(filters).find(
          (key) => key !== "inputData"
        );

        transformedCriteria[inputData.id] = {
          [filterType.toLowerCase().replace("equal", "eq")]:
            filters[filterType],
        };
      }
    }
    return transformedCriteria;
  }
  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "created";
        case "USER_INVITED":
          return "invited";
        case "USER_VERIFIED":
          return "verified";
        case "USER_ACC_CREATED":
          return "active";
        case "SUSPENDED":
          return "suspended";
        default:
          return "-";
      }
    }
  }
}
